import React, {useContext} from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import {WHITE} from '../../../shared/style/colors';
import {WEIGHT, FONTS} from '../../../shared/style/typography';
import {DESKTOP, PHONE} from '../../../shared/style/breakpoints';
import {MobileContext} from '../../../shared/enhancers/mobile-enhancer';
import {MAX_PAGE_WIDTH} from '../../../shared/style/dimensions';

const ImproveContainer = glamorous.div(
  {
    position: 'absolute',
    top: '60%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: MAX_PAGE_WIDTH,
    margin: 'auto',
    [PHONE]: {
      textAlign: 'center',
      alignItems: 'center',
      top: '52%'
    }
  },
  ({customStyle}) => (customStyle ? customStyle : {})
);

const ImproveHeader = glamorous.h3({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontSize: 30,
  fontWeight: WEIGHT.ULTRA_BLACK,
  lineHeight: '44px',
  margin: 0,
  marginBottom: 57,
  textAlign: 'center',
  [PHONE]: {
    fontSize: 24,
    lineHeight: '37px',
    marginBottom: 35
  }
});

const ImproveItems = glamorous.div({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '20px 0',
  margin: 'auto',
  [DESKTOP]: {
    gridTemplateColumns: 'repeat(2, 525px)',
    gap: '35px 42px'
  }
});

const ImproveTitle = glamorous.h3({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontSize: 24,
  fontWeight: WEIGHT.ULTRA_BLACK,
  lineHeight: '44px',
  marginTop: 11,
  [PHONE]: {
    marginBottom: 24,
    textAlign: 'left',
    fontSize: 20
  }
});

const ImproveContent = glamorous.p({
  fontFamily: `${FONTS.CEREBRI_SANS_PRO} !important`,
  fontSize: 24,
  fontWeight: WEIGHT.NORMAL,
  lineHeight: '44px',
  margin: 0,
  [PHONE]: {
    textAlign: 'left',
    fontSize: 20
  }
});

const ImproveElement = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  background: WHITE,
  boxShadow: '0px 5px 44.9826px rgba(0, 0, 0, 0.1)',
  borderRadius: 10,
  padding: '56px 60px',
  [PHONE]: {
    padding: '32px 30px'
  }
});

const ImproveImage = glamorous.img({
  width: 55,
  height: 55
});

const improvements = [
  {
    icon: 'https://img.stackshare.io/fe/landing/lock_icon.svg',
    title: 'Improve governance',
    description: 'Use a dynamic tech radar to set up guard rails'
  },
  {
    icon: 'https://img.stackshare.io/fe/landing/rocket_icon.svg',
    title: 'Ship faster',
    description: 'Reduce tech sprawl and speed up dev cycles'
  },
  {
    icon: 'https://img.stackshare.io/fe/landing/tech_debt_new.svg',
    title: 'Shrink tech debt',
    description: 'Get visibility into versions and overlapping tech'
  },
  {
    icon: 'https://img.stackshare.io/fe/landing/risk.svg',
    title: 'Reduce risk',
    description: 'Consolidate versions/tools to reduce attack surface area'
  }
];

const StackshareImprovements = ({customStyle = {}}) => {
  const isMobile = useContext(MobileContext);
  return (
    <ImproveContainer customStyle={customStyle}>
      <ImproveHeader>
        {!isMobile
          ? 'StackShare Enterprise helps engineering orgs'
          : 'StackShare Enterprise helps you'}
      </ImproveHeader>
      <ImproveItems>
        {improvements.map((element, index) => (
          <ImproveElement key={index}>
            <ImproveImage src={element.icon} />
            <ImproveTitle>{element.title}</ImproveTitle>
            <ImproveContent>{element.description}</ImproveContent>
          </ImproveElement>
        ))}
      </ImproveItems>
    </ImproveContainer>
  );
};

StackshareImprovements.propTypes = {
  customStyle: PropTypes.object
};

export default StackshareImprovements;
